export default {
  leaves01: {
    url: "/assets/sfx/leaves01.mp3"
  },
  leaves02: {
    url: "/assets/sfx/leaves02.ogg"
  }
};